import API from 'services/API';

export function getBanksForName(name) {
  return API.request(
    {
      method: 'GET',
      url: `/dicts/banks/name`,
      params: { name },
    },
    true,
  );
}
export function getBanksForBik(bik) {
  return API.request(
    {
      method: 'GET',
      url: `/dicts/banks/bik`,
      params: { bik },
    },
    true,
  );
}
